import { ApiBackendError, ApiError, ApiNetworkError } from '@/teoCore/errors/ApiError';
import { TeoError } from '@/teoCore/errors/TeoError';
import type { SubscriptionConfig } from '@/teoCore/TeoApi';
import { TeoCore } from '@/teoCore/TeoCore';

type SubscriptionConfigState =
  | {
      data: SubscriptionConfig | null;
      error: TeoError | null;
      loading: true;
    }
  | {
      data: null;
      error: TeoError;
      loading: false;
    }
  | {
      data: SubscriptionConfig;
      error: null;
      loading: false;
    };

async function fetchSubscriptionConfig(host: string) {
  try {
    const result = await TeoCore.instance.api.getSubscriptionConfig(host);

    if (TeoError.isTeoError(result)) {
      if (ApiError.matches(result) && result.status === 404) {
        return {
          generic_users: [],
          use_generic_users: false,
          use_named_users: true,
        };
      }
      throw result;
    }
    // TODO@ioss
    // TeoCore.instance.dynamicConfig.update('brandFitEnabled', result.show_brandfit ? true : false);
    TeoCore.instance.dynamicConfig.update(
      'subscriptionName',
      result.subscription_name ? result.subscription_name : '',
    );
    if (result.usage_quotas?.ANALYSIS) {
      TeoCore.instance.updateUsageQuota(result.usage_quotas.ANALYSIS);
    }
    return result;
  } catch (error) {
    if (ApiBackendError.matches(error, 'ApiBackendError')) {
      return error as ApiBackendError;
    } else if (TeoError.isError(error)) {
      return new ApiBackendError(
        {
          message: error.message,

          error: error.name,
        },
        ApiError.getStatus(error) ?? 0,
      );
    } else {
      return new ApiBackendError(
        {
          message: String(error),
          error: 'Systemfehler',
        },
        ApiError.getStatus(error) ?? 0,
      );
    }
  }
}

function loadSubscriptionConfig(): Promise<SubscriptionConfig | ApiBackendError> {
  const host = window?.location?.hostname ?? '';
  if (host === 'localhost') {
    return new Promise((resolve, reject) => {
      // if (Math.random() > 0.5) {
      //   throw new TypeError('Network Error');
      // }
      setTimeout(() => fetchSubscriptionConfig(host).then(resolve).catch(reject), 1000);
    });
  }
  return fetchSubscriptionConfig(host);
}

let subscriptionConfig = $state<SubscriptionConfigState>({
  data: null,
  error: null,
  loading: true,
});

let subscriptionConfigPromise: Promise<unknown> | null = null;

export function useSubscriptionConfig() {
  if (!subscriptionConfigPromise) {
    subscriptionConfigPromise = loadSubscriptionConfig()
      .then((config) => {
        if (TeoError.isTeoError(config)) {
          subscriptionConfig = {
            data: null,
            error: config,
            loading: false,
          };
        } else {
          subscriptionConfig = {
            data: config,
            error: null,
            loading: false,
          };
        }
      })
      .catch((error) => {
        subscriptionConfig = {
          data: null,
          error: TeoError.isTeoError(error) ? error : new ApiNetworkError(error),
          loading: false,
        };
      });
  }

  return {
    get current() {
      return subscriptionConfig;
    },
  };
}
